import { useContext } from 'react';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';

export const useBundleMiniFbtLayout = ({ itemId }) => {
  const storeId = useStoreId();
  const { data: productData } = useDataModel('clientOnlyProduct', {
    variables: {
      itemId,
      storeId
    },
    skip: !itemId,
    ssr: false
  });

  const ctx = useContext(ExperienceContext);
  const { referer, isServer } = ctx;

  return {
    productData,
    referer,
    isServer
  } || {};
};